<template>
<div class="show_on_mobile">
<ScrollPanel style="width: 100%; height: 100%" class="left_sidebar_scroll">
<Sidebar v-model:visible="$store.state.ui.offcanvasmenu" >
  <template #header>    
    <img class="toffset_menu_logo " :src="headerlogo">
  
  </template>

<Divider class="mt-0 mb-4"/>
<leftSidebarItem v-for="item in $store.state.ui.usermenu" :key="item.key" :data="item"></leftSidebarItem>

</Sidebar>
</ScrollPanel>
</div>
</template>

<script>
import leftSidebarItem from  "./leftSidebarItem"
export default {

  name: 'OffcanvasMenu',
  components:{
  	leftSidebarItem
  },
  data () {
    return {
    	headerlogo:require('../../assets/verify_logo.png'),
    }
  }
}
</script>

<style lang="css" scoped>
</style>